/* eslint-disable */
// import { Switch } from "@material-ui/core";
import { WindowTitle } from "@saleor/components/WindowTitle";
import { sectionNames } from "@saleor/intl";
import { shipmentListUrlSortField } from "@saleor/shipment/urls";
import { asSortParams } from "@saleor/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, RouteComponentProps, Switch } from "react-router";

import { hotsearchListPath, HotsearchListUrlQueryParams } from "./urls";

import HotsearchListComponent from "./views/HotsearchList";

const HotsearchList: React.FC<RouteComponentProps<{}>> = ({ location }) => {
  const qs = parseQs(location.search.substr(1));
  const params: HotsearchListUrlQueryParams = asSortParams(
    qs,
    shipmentListUrlSortField
  );
  return <HotsearchListComponent params={params} />;
};

export const HotsearchSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.hotsearch)} />
      <Switch>
        <Route exact path={hotsearchListPath} component={HotsearchList} />
        {/* <Route path={shipmentPath(":id")} component={ShipmentDetails} /> */}
      </Switch>
    </>
  );
};

export default HotsearchSection;
